export function fullSizeText({ containerSelector = ".main-header", targetSelector = "[type-full]", padding = 0, minFontSize = 10, maxFontSize = 1000, responsive = true } = {}) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const containerWidth = () => {
        const containerWidth = container.clientWidth;
        const containerPadding = parseFloat(getComputedStyle(container).paddingLeft) + parseFloat(getComputedStyle(container).paddingRight);

        return containerWidth - padding * 2 - containerPadding;
    };

    const fitText = el => {
        el.style.whiteSpace = "nowrap";
        el.style.display = "inline-block";
        el.style.width = "auto";

        let size = minFontSize;
        el.style.fontSize = size + "px";

        // Estimate size in one step
        size = Math.min(maxFontSize, Math.max(minFontSize, size * (containerWidth() / el.scrollWidth)));
        el.style.fontSize = size + "px";

        // Fine-tune for pixel-perfect fit
        while (el.scrollWidth > containerWidth() && size > minFontSize) {
            el.style.fontSize = --size + "px";
        }
        while (el.scrollWidth < containerWidth() && size < maxFontSize) {
            el.style.fontSize = ++size + "px";
        }
    };

    const applyFit = () => document.querySelectorAll(targetSelector).forEach(fitText);

    applyFit();
    if (responsive) window.addEventListener("resize", applyFit);
}
